export default "__VITE_ASSET__CHbNXFQ___"